import React, { Component } from 'react';
import OtpField from '../../UI/otpField/otpField';
import OtpTimer from '../../UI/OtpTimer/OtpTimer';
import { errorCode, errorMsg } from '../../../ErrorCode/ErrorCode';
import './RegOtp.scss'

interface IRegOtpProps {
    label: string;
    otpTimer: number;
    eleId: string;
    onChange: (value: string) => string | void;
    resendClicked: () => string | void;
    disableOtp?: boolean;
    invalidOtp?: boolean;
}

let resendTimer: any;

class RegOtp extends Component<IRegOtpProps> {
    resendTimer: any;

    state = {
        otp: '',
        isResend: false,
        timer: this.props.otpTimer
    };

    enableClock = () => {
        this.resendTimer = setInterval(() => {
            this.setState((prevState: any) => {
                let temp = prevState.timer - 1;

                if (temp === 0) {
                    clearInterval(this.resendTimer);
                    return { timer: this.props.otpTimer, isResend: true };
                }

                return { timer: temp };
            });
        }, 1000);
    };

    componentDidMount() {
        this.enableClock();
    }

    componentWillUnmount() {
        clearInterval(this.resendTimer);
    }

    setOtp = (value: any) => {
        this.setState({ otp: value });
        this.props.onChange(value);
    };

    resendClicked = () => {
        clearInterval(this.resendTimer); // ✅ clear previous timer
        this.setState({ isResend: false, timer: this.props.otpTimer });
        this.props.resendClicked();

        setTimeout(() => this.enableClock(), 500);
    };

    render() {
        return (
            <div className='regOtp'>
                <p className='otpLbl'>{this.props.label}</p>

                <div className='otpInput'>
                    <OtpField
                        onChange={(value) => this.setOtp(value)}
                        eleId={this.props.eleId}
                        disableOtp={this.props.disableOtp}
                        invalidOtp={this.props.invalidOtp}
                    />

                    {this.props.invalidOtp && (
                        <p className='incrtOtp'>{errorMsg(errorCode.FE05)}</p>
                    )}
                </div>

                {this.state.isResend ? (
                    <div className='resendOtpText'>
                        <label className='otpNotRecv'>Didn’t receive the OTP?</label>
                        <label className='resendOtpLink' onClick={this.resendClicked}>
                            Resend now
                        </label>
                    </div>
                ) : (
                    <div className='otpTimer'>
                        <OtpTimer timer={this.state.timer} />
                    </div>
                )}
            </div>
        );
    }
}

export default RegOtp